import { CreateMyAirdropWalletFormValues } from "./types-dto"

export const createMyAirdropWalletFormValuesInitialValue = (): CreateMyAirdropWalletFormValues => {
    return {
        address: '',
        chain: 'SOL'
    }
}